/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export class ResponsiveNavCodes {
  public static NAV_LEVEL_1 = 1;
  public static NAV_LEVEL_2 = 2;
  public static NAV_CLOSE_ALL = 'NAV_CLOSE_ALL';
  public static NAV_OPEN = 'NAV_OPEN';
  public static NAV_CLOSE = 'NAV_CLOSE';
  public static NAV_TOGGLE = 'NAV_TOGGLE';
  public static NAV_CLASS_HAMBURGER_MENU = 'open-hamburger-menu';
  public static NAV_CLASS_OVERFLOW_MENU = 'open-overflow-menu';
  public static NAV_CLASS_TRIGGER_1 = 'header-hamburger-trigger';
  public static NAV_CLASS_TRIGGER_2 = 'header-overflow-trigger';
  public static NAV_CLASS_LEVEL_1 = 'clr-nav-level-1';
  public static NAV_CLASS_LEVEL_2 = 'clr-nav-level-2';
}
